import { computed } from "vue";
import { useStore } from "vuex";
import { Permission, hasPermission } from "@/utils/permissions";
import { useRolePermissions } from "@/composables/organization/useRolePermissions";

export function usePermissions() {
  const store = useStore();
  const userRole = computed(() => store.getters.account?.data?.role);

  const { data: rolePermsData } = useRolePermissions();
  const orgPermissions = computed(() => rolePermsData.value?.rolePermissions ?? null);

  const can = (permission: Permission) =>
    hasPermission(userRole.value, permission, orgPermissions.value);

  return {
    userRole,
    orgPermissions,
    can,
    canManageOrganization: computed(() => can(Permission.MANAGE_ORGANIZATION)),
    canManageUsers: computed(() => can(Permission.MANAGE_USERS)),
    canManageBilling: computed(() => can(Permission.MANAGE_BILLING)),
    canManageIntegrations: computed(() => can(Permission.MANAGE_INTEGRATIONS)),
    canManagePhoneNumbers: computed(() => can(Permission.MANAGE_PHONE_NUMBERS)),
    canManageContacts: computed(() => can(Permission.MANAGE_CONTACTS)),
    canDeleteRecords: computed(() => can(Permission.DELETE_RECORDS)),
    canImportExport: computed(() => can(Permission.IMPORT_EXPORT)),
    canManageTemplates: computed(() => can(Permission.MANAGE_TEMPLATES)),
    canManageSequences: computed(() => can(Permission.MANAGE_SEQUENCES)),
    canCommunicate: computed(() => can(Permission.COMMUNICATION)),
    canViewReports: computed(() => can(Permission.VIEW_REPORTS)),
  };
}
